(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  // Image gallery.
  const primaryImage = document.querySelector('.images__main')

  document.querySelectorAll('.images__thumbnails a').forEach(function(thumbnail) {
    thumbnail.addEventListener('click', function(e) {
      e.preventDefault()

      const imgUrl = thumbnail.getAttribute('href')

      primaryImage.classList.add('active')
      primaryImage.querySelector('img').setAttribute('src', imgUrl)
      primaryImage.querySelector('img').onload = function() {
        primaryImage.classList.remove('active')
      }
    })
  })


  // Variant radios.
  document.querySelectorAll('variant-radios input').forEach(function(variantRadio) {
    variantRadio.addEventListener('click', function(e) {
      const variantId = e.target.value
      const form = e.target.form
      const price = e.target.dataset.price

      // Set the selected variant.
      form.querySelector('input[name="id"]').value = variantId

      // Display the variant's price.
      document.getElementById('price').innerHTML = e.target.dataset.price
    })
  })


  // Quantity number picker.
  document.querySelectorAll('.number-picker').forEach(function(numberPicker) {
    let inpt = numberPicker.querySelector('input')
    let inptValue = parseInt(inpt.value)

    numberPicker.querySelector('.number-picker__decrease').addEventListener('click', function(e) {
      if (inptValue > 1) {
        inpt.value = (inptValue -= 1)
      }
    })

    numberPicker.querySelector('.number-picker__increase').addEventListener('click', function(e) {
      inpt.value = (inptValue += 1)
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            const slider = window.ae.tns({
              container: '.image-carousel .slides',
              items: 2,
              mode: 'gallery',
              slideBy: 'page',
              autoplay: false,
              autoplayButtonOutput: false,
              controls: false,
              controlsText: ["", ""],
              nav: false,
              mouseDrag: true,
              responsive: {
                768: {
                  items: 4
                },
                1260: {
                  controls: true
                }
              }
            })
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-page"] && !Shopify.designMode) return;
  try {
    
document.getElementById('stars').addEventListener('change', function(e) {
  let ratingStars = document.getElementById('rating-stars')
  const parts = e.target.value.split('.')
  const wholeNumber = parts[0]
  const decimal = parts[1]

  ratingStars.innerHTML = ''

  for (let i = 1; i <= wholeNumber; i++) {
    ratingStars.innerHTML += '<i class="icn-star" aria-hidden="true"></i>'
  }

  if (decimal == 5) {
    ratingStars.innerHTML += '<i class="icn-star-half" aria-hidden="true"></i>'
  }
})

  } catch(e) { console.error(e); }
})();
})();
